var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 1.56667C1.33337 1.1933 1.33337 1.00661 1.40604 0.864006C1.46995 0.738565 1.57194 0.636578 1.69738 0.572662C1.83999 0.5 2.02667 0.5 2.40004 0.5L13.6 0.5C13.9734 0.5 14.1601 0.5 14.3027 0.572662C14.4281 0.636578 14.5301 0.738565 14.594 0.864006C14.6667 1.00661 14.6667 1.1933 14.6667 1.56667V2.01293C14.6667 2.19213 14.6667 2.28173 14.6448 2.36504C14.6254 2.43887 14.5935 2.50882 14.5504 2.57184C14.5018 2.64295 14.4341 2.70164 14.2986 2.819L10.0348 6.51434C9.89936 6.6317 9.83166 6.69038 9.78304 6.76149C9.73995 6.82451 9.70801 6.89446 9.68861 6.96829C9.66671 7.05161 9.66671 7.14121 9.66671 7.3204V10.8056C9.66671 10.936 9.66671 11.0011 9.64568 11.0575C9.6271 11.1073 9.59688 11.1519 9.55754 11.1877C9.51302 11.2281 9.4525 11.2524 9.33145 11.3008L7.06478 12.2074C6.81975 12.3054 6.69724 12.3545 6.59889 12.334C6.51288 12.3161 6.43741 12.265 6.38888 12.1918C6.33337 12.1081 6.33337 11.9762 6.33337 11.7122L6.33337 7.3204C6.33337 7.14121 6.33337 7.05161 6.31148 6.96829C6.29207 6.89446 6.26013 6.82451 6.21705 6.76149C6.16843 6.69038 6.10072 6.6317 5.9653 6.51434L1.70145 2.819C1.56603 2.70164 1.49832 2.64295 1.4497 2.57184C1.40662 2.50882 1.37468 2.43887 1.35527 2.36504C1.33337 2.28173 1.33337 2.19213 1.33337 2.01293L1.33337 1.56667Z",
    stroke: "#D1D1D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.fd06fbd9cdd596428fe7cb3da8904fa3.svg";
export { ForwardRef as ReactComponent };